import { getFollowerRequests, userActionRequest } from '../../../utils/requests/belay_requests';
import { addActionsToConnections, addActionsToConnection } from '../utils/belay_helpers';
import { updateUserActionRequestState, setOverrideUser } from './userOverrides';
import { LOADING, FAILED } from '../constants';

export const POPULATE_FOLLOWER_REQUESTS = 'POPULATE_FOLLOWER_REQUESTS';
export const REMOVE_FOLLOWER_REQUEST_FROM_LIST = 'REMOVE_FOLLOWER_REQUEST_FROM_LIST';

const respondWith = (f = () => {}) => ({ href, method, userConnection, actionKey }) => {
  return dispatch => {
    // set loading for action to true
    dispatch(updateUserActionRequestState(userConnection, actionKey, LOADING));

    userActionRequest(href, method)
      .then(resp => {
        const updatedUserConnection = addActionsToConnection(resp);
        dispatch(setOverrideUser(updatedUserConnection));

        f(dispatch, updatedUserConnection);
      })
      .catch(err => {
        // set loading for action to false
        dispatch(updateUserActionRequestState(userConnection, actionKey, FAILED));
        console.log('err', err);
      });
  };
};

export const populateFollowerRequests = () => {
  return dispatch => {
    getFollowerRequests()
      .then(resp => {
        dispatch({
          type: POPULATE_FOLLOWER_REQUESTS,
          payload: addActionsToConnections(resp.followRequests.received)
        });
      })
      .catch(err => {
        console.log('ERR', err);
      });
  };
};

export const denyFollowRequest = respondWith((dispatch, userConnection) =>
  dispatch({ type: REMOVE_FOLLOWER_REQUEST_FROM_LIST, payload: userConnection.user.id })
);
export const acceptFollowRequest = respondWith((dispatch, userConnection) =>
  dispatch({ type: REMOVE_FOLLOWER_REQUEST_FROM_LIST, payload: userConnection.user.id })
);
export const requestFollow = respondWith();
export const retractRequestFollow = respondWith();

export const initialFollowerRequestsState = {
  followerRequests: []
};

export default function followerRequests(state = initialFollowerRequestsState, action) {
  switch (action.type) {
    case POPULATE_FOLLOWER_REQUESTS:
      return {
        ...state,
        followerRequests: action.payload
      };
    case REMOVE_FOLLOWER_REQUEST_FROM_LIST:
      return {
        ...state,
        followerRequests: [
          ...state.followerRequests.filter(followerRequest => {
            return followerRequest.user.id !== action.payload;
          })
        ]
      };
    default:
      return state;
  }
}
